import classNames from '@/utils/classNames';

export interface SvgProps extends React.ComponentPropsWithoutRef<'svg'> {
  ref?: React.Ref<SVGSVGElement>;
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  children?: React.ReactNode;
  'data-testid'?: string;
}

const Svg = ({
  ref,
  className,
  width = 24,
  height = 24,
  fill = 'none',
  ...props
}: SvgProps) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox={`0 0 ${width} ${height}`}
    aria-hidden="true"
    className={classNames(
      {
        'w-3': width === 12,
        'h-3': height === 12,
        'w-4': width === 16,
        'h-4': height === 16,
        'w-6': width === 24,
        'h-6': height === 24,
        'w-8': width === 32,
        'h-8': height === 32,
        'w-10': width === 40,
        'h-10': height === 40,
        'w-12': width === 48,
        'h-12': height === 48,
        'w-14': width === 56,
        'h-14': height === 56,
        'w-16': width === 64,
        'h-16': height === 64,
        'w-20': width === 80,
        'h-20': height === 80,
        'w-24': width === 96,
        'h-24': height === 96,
        'w-28': width === 112,
        'h-28': height === 112,
        'w-32': width === 128,
      },
      className,
    )}
    {...props}
    ref={ref}
  />
);

export default Svg;
